module.exports = __webpack_public_path__ + "img/notification.74a6a435.svg";